module.exports = __webpack_public_path__ + "static/logo-1a1d114a6d6993385e03d8c9f14fa8a3.svg";